import { render, staticRenderFns } from "./IWEmpty.vue?vue&type=template&id=a5422a50&scoped=true"
import script from "./IWEmpty.vue?vue&type=script&lang=js"
export * from "./IWEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5422a50",
  null
  
)

export default component.exports